"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventValidatorToJSON = exports.EventValidatorFromJSONTyped = exports.EventValidatorFromJSON = void 0;
var runtime_1 = require("../runtime");
function EventValidatorFromJSON(json) {
    return EventValidatorFromJSONTyped(json, false);
}
exports.EventValidatorFromJSON = EventValidatorFromJSON;
function EventValidatorFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'eventTypeId': json['eventTypeId'],
        'jsonValidator': !(0, runtime_1.exists)(json, 'jsonValidator') ? undefined : json['jsonValidator'],
    };
}
exports.EventValidatorFromJSONTyped = EventValidatorFromJSONTyped;
function EventValidatorToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'eventTypeId': value.eventTypeId,
        'jsonValidator': value.jsonValidator,
    };
}
exports.EventValidatorToJSON = EventValidatorToJSON;
